import { ClickNavigationProps } from '../../../../../components/NavigationWithSideBar/ClickNavigation'
import { PreciseFPContactSyncSettings } from './PreciseFPContactSyncSettings'

export const PreciseFPSpecificSettings = (): ClickNavigationProps[] => {
  return [{ id: 'contactSync', label: 'Contact Sync', content: () => <PreciseFPContactSyncSettings /> }]
}
